import React from 'react';
import Image, { ImageProps } from 'next/legacy/image';
import Tooltip from '@mui/material/Tooltip';

interface HeaderButtonProps {
  icon: ImageProps['src'];
  alt: string;
  label: string;
  onClick: () => void;
  tooltip?: string;
  className?: string;
  iconWidth?: number;
  iconHeight?: number;
  labelClassName?: string;
  gapClassName?: string;
}

const HeaderButton: React.FC<HeaderButtonProps> = ({
  icon,
  alt,
  label,
  onClick,
  className = 'items-center uppercase h-7',
  iconWidth = 22,
  iconHeight = 22,
  labelClassName = '',
  gapClassName = '',
}) => {
  const button = (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center ${gapClassName} ${className}`}
    >
      <span className="flex items-center flex-shrink-0">
        <Image src={icon} alt={alt} width={iconWidth} height={iconHeight} />
      </span>
      <span
        className={`${
          gapClassName ? '' : 'px-2'
        } pt-px hover:text-gold-hover hidden md:inline ${labelClassName}`}
      >
        {label}
      </span>
    </button>
  );
  return button;
};

export default HeaderButton;
